<template>
  <div v-if="hasNotes" class="email-delivery-notes">
    <!-- Bounce info -->
    <bounce-capsule v-if="hasBounceInfo" :bounce-info="bounceInfo" />
    <!-- Auto-response sent -->
    <auto-response-capsule v-if="autoResponseSent" />
    <!-- CCs -->
    <cc-capsule v-if="hasCCs" :ccs="ccs" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IBounceInfo } from '@/types/data-objects/item-histories'

export default defineComponent({
  name: 'EmailDeliveryNotes',

  props: {
    autoResponseSent: {
      type: Boolean,
      required: true,
    },
    ccs: {
      type: Array as () => string[],
      default: null,
    },
    bounceInfo: {
      type: Object as () => IBounceInfo,
      default: null,
    },
  },

  computed: {
    hasNotes(): boolean {
      return this.hasCCs || this.hasBounceInfo || this.autoResponseSent
    },
    hasCCs(): boolean {
      return this.ccs !== null && this.ccs.length > 0
    },
    hasBounceInfo(): boolean {
      return this.bounceInfo !== null
    },
  },
})
</script>

<style lang="scss">
.email-delivery-notes {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  // Hack to allow wrapping to have vertical gap...
  // Subtract top margin off the container and add it to all children.
  // I've added back 8px because I want a default margin of 8px
  // but rather than just doing "0" I want to show -8px + 8px for clarity.
  margin-top: calc(-8px + 8px);

  > * {
    margin-top: 8px;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }
}
</style>
